'use strict';

var _bus = require('./bus');

var _bus2 = _interopRequireDefault(_bus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClientTable = require('./v-client-table');
var ServerTable = require('./v-server-table');


module.exports = {
  ClientTable: ClientTable,
  ServerTable: ServerTable,
  Event: _bus2.default
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/index.js
// module id = e9ss
// module chunks = 0